import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as Menubar from '@radix-ui/react-menubar';
import { createContext, use } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { BottomDrawer, BottomDrawerProps } from '../BottomDrawer/BottomDrawer';
import { MenuItemIntent, OverflowMenu } from '../OverflowMenu';

const ResponsiveMenuContext = createContext<{ isMobile: boolean }>({
  isMobile: false,
});

export const ResponsiveMenu = (
  props: Menubar.MenubarProps | BottomDrawerProps,
) => {
  const { isMobile } = useIsMobile();

  return (
    <ResponsiveMenuContext value={{ isMobile }}>
      {isMobile ? <BottomDrawer {...props} /> : <OverflowMenu {...props} />}
    </ResponsiveMenuContext>
  );
};

const ResponsiveMenuTrigger = (
  props: Menubar.MenubarTriggerProps | DialogPrimitive.DialogTriggerProps,
) => {
  const { isMobile } = use(ResponsiveMenuContext);
  return isMobile ? (
    <BottomDrawer.Trigger {...props} />
  ) : (
    <OverflowMenu.Trigger {...props} />
  );
};

const ResponsiveMenuContent = (
  props: Menubar.MenubarContentProps | DialogPrimitive.DialogContentProps,
) => {
  const { isMobile } = use(ResponsiveMenuContext);
  return isMobile ? (
    <BottomDrawer.Content {...props} />
  ) : (
    <OverflowMenu.Content {...props} />
  );
};

export type ResponsiveMenuItemProps = Menubar.MenubarItemProps & {
  closeOnClick?: boolean;
  intent?: MenuItemIntent;
};

const ResponsiveMenuItem = (props: ResponsiveMenuItemProps) => {
  const { isMobile } = use(ResponsiveMenuContext);
  const { onSelect, ...drawerProps } = props;
  const { closeOnClick, ...menuProps } = props;

  return isMobile ? (
    <BottomDrawer.Item {...drawerProps} />
  ) : (
    <OverflowMenu.Item {...menuProps} />
  );
};

const ResponsiveMenuSeparator = (props: Menubar.MenubarSeparatorProps) => {
  const { isMobile } = use(ResponsiveMenuContext);
  return isMobile ? (
    <>{props.children}</>
  ) : (
    <OverflowMenu.Separator {...props} />
  );
};

ResponsiveMenu.Trigger = ResponsiveMenuTrigger;
ResponsiveMenu.Content = ResponsiveMenuContent;
ResponsiveMenu.Item = ResponsiveMenuItem;
ResponsiveMenu.Separator = ResponsiveMenuSeparator;
